import { Checkbox } from '@wix/wix-ui-tpa/cssVars';
import React from 'react';
import { useConfig } from '../../contexts/config-context';
import { useTranslation } from '../../sdk/components';
import { formatCurrency } from '../../utils/format-currency';
import BoxSelectionItem from '../box-selection-item';
import { getCurrencyAriaLabel } from '../shared/payment-field-utils';
export const DonationFieldOption = (props)=>{
    const { t } = useTranslation();
    const { price, inputId, ...rest } = props;
    const { currency, regionalFormat } = useConfig();
    const formattedCurrency = formatCurrency({
        amount: price,
        currency: currency?.code,
        locale: regionalFormat
    });
    return /*#__PURE__*/ React.createElement(BoxSelectionItem, {
        ...rest,
        inputId: inputId,
        content: formattedCurrency,
        "aria-label": `${getCurrencyAriaLabel(t, currency)} ${price}`
    });
};
// fix to include Checkbox styles in bundle https://wix.slack.com/archives/CH32ANHNF/p1715770531405829?thread_ts=1715607100.247089&cid=CH32ANHNF
DonationFieldOption.includeCheckboxInBundle = Checkbox;

//# sourceMappingURL=donation-field-option.js.map